<template>
    <b-container>
        <b-card v-if="contactId === null">
        <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
            <b-breadcrumb-item active>Create Contact</b-breadcrumb-item>
        </b-breadcrumb>
        <h4>Create a new contact.</h4>
        </b-card>
        <b-card v-if="contactId != null">
        <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
            <b-breadcrumb-item :to="{name: 'ward-contact-notes', params: { wardId: wardId, contactId:contactId}}">{{contact.first_name}} {{contact.last_name}}</b-breadcrumb-item>
            <b-breadcrumb-item active>Edit</b-breadcrumb-item>
        </b-breadcrumb>
        </b-card>
        <b-card>
        <b-row v-if="contactId!==null">
            <b-col align="left">
            <h6>Consent State: <b-badge :variant="(contact.consent_state=='ENROLLED')?'success':'danger'">{{contact.consent_state}}</b-badge></h6>
            <h6>Consent Updated: {{contact.consent_updated_on!==null?$moment.utc(contact.consent_updated_on).fromNow():'Not Available'}}</h6>
            </b-col>
        </b-row>
        </b-card>
        <b-card>
        <b-form @submit="onSubmit">
        <b-row>
            <b-col>
        <b-form-group
            id="input-group-1"
            label="First Name:"
            label-for="input-1"
            description="Contact first name.">
            <b-form-input
                id="input-1"
                v-model="contact.first_name"
                type="text"
                placeholder="Enter First Name"
                required
            ></b-form-input>
        </b-form-group>
        </b-col>
        <b-col>
        <b-form-group
            id="input-group-2"
            label="Last Name:"
            label-for="input-2"
            description="Contact last name.">
            <b-form-input
                id="input-2"
                v-model="contact.last_name"
                type="text"
                placeholder="Enter Last Name"
                required
            ></b-form-input>
        </b-form-group>
        </b-col>
        </b-row>
          <b-row>
            <b-col>
        <b-form-group
            id="input-group-100"
            label="Phone Country Code"
            label-for="input-group-100"
            description="Set the tel country code if not US">
            <b-form-select
              :disabled="!contact.send_through_whatsapp"
              v-model="contact.phone_country_code"
              :options="countryCodeOptions"></b-form-select>
        </b-form-group>
            </b-col>
            <b-col>
        <b-form-group
            id="input-group-3"
            label="Phone Number:"
            label-for="input-3"
            description="Contact Phone NUmber.">
            <b-form-input
                id="input-3"
                v-model="contact.phone_number"
                type="tel"
                placeholder="Enter Contact Phone Number"
                required
                @input="acceptNumber"
            ></b-form-input>
        </b-form-group>
              </b-col>
            </b-row>
        <b-row>
            <b-col>
        <b-form-group
            id="input-group-10"
            label="Gender"
            label-for="input-group-10"
            description="Optional gender field, this will override the primary organization gender.">
            <b-form-select v-model="contact.gender" :options="genderOptions"></b-form-select>
        </b-form-group>
        </b-col>
        <b-col>
        <b-form-group
            id="input-group-30"
            label="Contact Type"
            label-for="input-group-30"
            description="Optional Field to define how auto greetings are generated when sending messages.">
            <b-form-select v-model="contact.contact_type" :options="contactTypeOptions"></b-form-select>
        </b-form-group>
        </b-col>
        <b-col>
                <b-form-group
                id="input-group-0"
                label="Title/Calling"
                label-for="input-1"
                description="Contact Title/Calling">
                <b-form-input
                    id="input-0"
                    v-model="contact.title"
                    type="text"
                    placeholder="Bishop or President or Secretary"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        <b-col>
            <b-form-group
                            id="input-group-5"
                            label="Preferred Language"
                            label-for="input-5"
                            description="Preferred Language to receive messages in default is defined at ward/org level">
                            <b-form-select
                                v-model="contact.preferred_language"
                                :options="language_options"
                                ></b-form-select>
                        </b-form-group>
        </b-col>
        </b-row>
        <b-row>
            <b-col>
        <b-form-group
            id="input-group-4"
            label="Primary Organization/Group:"
            label-for="input-4"
            description="Primary Ward Organization/Group">
            <b-form-select
                id="input-3"
                v-model="contact.primary_organization"
                :options="primary_options"
                required
            ></b-form-select>
        </b-form-group>
        </b-col>
        </b-row>
    <!-- TODO: needs to be moved out to another component, this will be re-used in a few -->
    <b-form-group
        label="Select Auxilary Organizations/Groups:"
        description="You will only see organizations where your primary org/group isn't already included."
        label-for="tags-component-select">
      <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
      <b-form-tags
        id="tags-component-select"
        v-model="contact.aux_organization"
        size="lg"
        class="mb-2"
        add-on-change
        no-outer-focus
      >
        <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
          <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag
                @remove="removeTag(tag)"
                :title="tag"
                :disabled="disabled"
                variant="info"
              >{{ tag }}</b-form-tag>
            </li>
          </ul>
          <b-form-select
            v-bind="inputAttrs"
            v-on="inputHandlers"
            :disabled="disabled || availableOptions.length === 0"
            :options="availableOptions"
          >
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value="">Choose an Organization...</option>
            </template>
          </b-form-select>
        </template>
      </b-form-tags>
    </b-form-group>
    <b-form-group>
        <b-form-checkbox
        v-model="contact.short_url_encode"
        name="check-button"
        switch>
            Short URL Encode Enabled
        </b-form-checkbox>
    </b-form-group>
    <b-form-group v-if="ward.whatsapp_service_enabled">
        <b-form-checkbox
        v-model="contact.send_through_whatsapp"
        name="check-button"
        switch>
            Use WhatsApp Enabled
        </b-form-checkbox>
    </b-form-group>
        <b-form-checkbox v-model="contact.disabled" name="check-button" switch :disabled="contact.consent_state=='UNSUBSCRIBED'">
            Contact Disabled
        </b-form-checkbox>
        <b-button type="submit" variant="primary" v-if="contactId!==null && isInRole('canModifyContact')" class="mt-3">Update</b-button>
        <b-button type="submit" variant="primary" v-if="contactId===null" class="mt-3">Create</b-button>
    </b-form>
    </b-card>
    </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";

export default {
    name: "WardContact",
    mixins: [userMixin],
    props: {
        wardId: {
            type: String,
            required: false,
        },
        contactId: {
            type: String,
            default: null,
            required: false
        },
        stakeId: {
            type: String,
            required: false
        }
    },
    data () {
        return {
            genderOptions: [],
            options: [],
            primary_options:[],
            organizations:[],
            language_options: [],
            contactTypeOptions: [],
            countryCodeOptions: [],
            contact :{
                contact_id: null,
                ward_id : null,
                stake_id: null,
                first_name: null,
                last_name: null,
                phone_number: null,
                primary_organization: null,
                aux_organization: [],
                ward: {
                    ward_name: null,
                    ward_id: null
                },
                disabled: false,
                consent_state: null,
                consent_updated_on: null,
                gender: null,
                title: null,
                preferred_language: null,
                short_url_encode: true,
                contact_type: 'ADULT',
                send_through_whatsapp: false,
                phone_country_code: "+1"
            },
            ward: {
                ward_name: null,
                send_consent: false,
                whatsapp_service_enabled: false,
            }
        }
    },
    computed: {
      availableOptions() {
        return this.options.filter(opt => this.contact.aux_organization.indexOf(opt.value) === -1);
      }

    },
    async mounted() {
        this.genderOptions = this.$store.state.frontEndSettings.gender_types;
        this.language_options = this.$store.state.frontEndSettings.ward_languages;
        this.contactTypeOptions = this.$store.state.frontEndSettings.contact_types;
        this.countryCodeOptions = this.$store.state.frontEndSettings.phone_country_codes;
        if(this.contactId!==null){
            this.contact = await this.getContact();
            this.acceptNumber();
        }
        if(this.wardId !== null || this.wardId !== '')
            await this.getOrganizations();
    },
    methods: {
        async getOrganizations() {
            try{
                const { data } = await WardApi.getWardOrganizations(this.wardId);
                //console.log(data);
                this.organizations = data.org_list;
                this.ward = data.ward;
                data.org_list.forEach(x=>{
                    if(x.primary){
                        this.primary_options.push({
                            value: x.org_code,
                            text: x.org_name

                        });
                    }else{
                        if(this.alreadyInCompositeOrgs(this.contact.primary_organization, x.org_code)){
                            return;
                        };
                        this.options.push({
                            value: x.org_code,
                            text: x.org_name

                        });
                    }
                });
            }catch(e) {
                handleError(e, "Error getting organizations");
            }

        },
        async getContact() {
            try{
                const { data } = await WardApi.getWardContact(this.wardId, this.contactId);
                return data;
            }catch (e) {
                handleError(e, "Error getting contact information");
            }
        },
        async onSubmit(event) {
            event.preventDefault();
            try{
                if(this.contactId!==null){
                    const { data } = await WardApi.updateWardContact(this.wardId, this.contactId, this.contact);
                    this.$router.push({ name: 'ward-contact-notes',params: { wardId: this.wardId, contactId: this.contactId}});
                    this.$toast.success("Successfully updated ward contact");
                }else{
                    this.contact.ward_id = this.wardId;
                    this.contact.stake_id = this.stakeId;
                    this.contact.ward = null;
                    const { data } = await WardApi.createWardContact(this.wardId,this.contact);
                    this.$router.push({ name: 'ward-list',params: { wardId: this.wardId}});
                    this.$toast.success("Successfully created ward contact");
                }

            } catch(e) {
                handleError(e, "Error trying to process contact request");
            }
        },
        acceptNumber() {
            var p = this.contact.phone_number.replace(/\D/g, '');
            var x = p.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            if(p.length==11)
                x = p.match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
            if(p.length===10){
                this.contact.phone_number = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                return
            }
            if(p.length===11)
                this.contact.phone_number = !x[3] ? x[2] : '(' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '');

        },
        alreadyInCompositeOrgs(primary_org, org) {
            let exists = false;
            this.organizations.forEach(x=>{
                if (x.org_code === org && x.composite_orgs!==null) {
                    exists =  x.composite_orgs.includes(primary_org);
                    return;
                }
            });
            return exists;
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
